// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6abaf09182996982475d","655":"1d8611985fe9a8523c3d"}[chunkId] + ".js";
};